import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Home from "../screens/HomeScreen";
import ProductScreen from "../screens/ProductScreen";
import ResponsiveProductScreen from "../screens/ResponsiveProductScreen";
import SearchResultsPage from "../screens/SearchResultsPage";
import PartsDiagramPage from "../screens/PartsDiagramPage";
import Checkout from "../screens/checkout";
import ResponsiveCheckout from "../screens/ResponsiveCheckout";
import InvoiceScreen from "../screens/InvoiceScreen";
import ResponsiveInvoiceScreen from "../screens/ResponsiveInvoiceScreen";
import CategoryPage from "../screens/CategoryPage";
import ResponsiveCategoryPage from "../screens/ResponsiveCategoryPage";
import ResponsiveTopNav from "../components/home/ResponsiveTopNav";
import AuthPage from "../screens/AuthPage";
import AdminRoute from "../components/auth/AdminRoute";
import AccountScreen from "../screens/AccountScreen";
import ContactPage from "../screens/ContactPage";
import ResponsiveHomeScreen from "../screens/ResponsiveHomeScreen";
import OrdersScreen from "../screens/OrdersScreen";
import OrderDetailScreen from "../screens/OrderDetailScreen";
import ShippingAddressScreen from "../screens/ShippingAddressScreen";
import PaymentMethodsScreen from "../screens/PaymentMethodsScreen";
import SupportScreen from "../screens/SupportScreen";
import AdminReturnsScreen from "../admin/AdminReturnsScreen";
import ResponsiveAccountScreen from "../screens/ResponsiveAccountScreen";
import ResponsiveSearchResultsPage from "../screens/ResponsiveSearchResultsPage";
import ResponsiveSupport from "../screens/ResponsiveSupport";
import ResponsiveAuthPage from "../screens/ResponsiveAuthPage";
import AdminMobile from "../admin/AdminMobile";
import ContactPageMobile from "../screens/ContactPageMobile";
import ScrollToTop from "../components/ScrollToTop";
import PrivacyPage from "../screens/PrivacyPage";
import TermsPage from "../screens/TermsPage";
import CheckoutBNPL from "../screens/CheckoutBNPL";
import InvoicePending from "../screens/InvoicePending";



/* ADMIN */
import DashboardScreen from "../admin/DashboardScreen.js";
import ListingsScreen from "../admin/ListingsScreen.js";
import CreateListingScreen from "../admin/CreateListingScreen";
import AdminOrdersScreen from "../admin/AdminOrdersScreen.js";
import AdminCustomersScreen from "../admin/AdminCustomersScreen.js";
import AdminAnalyticsScreen from "../admin/AdminAnalyticsScreen.js";
import AdminInventoryScreen from "../admin/AdminInventoryScreen.js";
import AdminMessagesScreen from "../admin/AdminMessagesScreen.js";
import CreateListingMobile from "../admin/CreateListingMobile";

function RouterInner() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <>
      <ScrollToTop />
      {!isAdmin && <ResponsiveTopNav />}
      <Routes>

        {/* PUBLIC ROUTES */}
 <Route path="/" element={<ResponsiveHomeScreen />} />
      <Route path="/product/:listingId" element={<ResponsiveProductScreen />} />
      <Route path="/search" element={<ResponsiveSearchResultsPage />} />
        <Route path="/diagram" element={<PartsDiagramPage />} />
 <Route path="/checkout" element={<ResponsiveCheckout />} />
   <Route path="/invoice/:id" element={<ResponsiveInvoiceScreen />} />
<Route path="/category/:categoryName" element={<ResponsiveCategoryPage />} />
<Route path="/account" element={<ResponsiveAccountScreen />} />
     <Route path="/auth" element={<ResponsiveAuthPage />} />
     <Route path="/contact" element={window.innerWidth <= 768 ? <ContactPageMobile /> : <ContactPage />} />
        <Route path="/account/orders" element={<OrdersScreen />} />
        <Route path="/account/orders/:id" element={<OrderDetailScreen />} />
   <Route path="/account/support" element={<ResponsiveSupport />} />
        <Route path="/admin/returns" element={<AdminRoute><AdminReturnsScreen /></AdminRoute>} />
<Route path="/privacy" element={<PrivacyPage />} />
<Route path="/terms" element={<TermsPage />} />
<Route path="/checkout/bnpl" element={<CheckoutBNPL />} />
<Route path="/invoice/pending" element={<InvoicePending />} />


        {/* ADMIN ROUTES */}
    <Route
  path="/admin"
  element={
    <AdminRoute>
      {window.innerWidth <= 768 ? <AdminMobile /> : <DashboardScreen />}
    </AdminRoute>
  }
/>
        <Route
          path="/admin/orders"
          element={
            <AdminRoute>
              <AdminOrdersScreen />
            </AdminRoute>
          }
        />

        <Route
          path="/admin/listings"
          element={
            <AdminRoute>
              <ListingsScreen />
            </AdminRoute>
          }
        />

     <Route
  path="/admin/create-listing"
  element={
    <AdminRoute>
      {window.innerWidth <= 768 ? <CreateListingMobile /> : <CreateListingScreen />}
    </AdminRoute>
  }
/>

<Route
  path="/admin/create-listing/:listingId"
  element={
    <AdminRoute>
      {window.innerWidth <= 768 ? <CreateListingMobile /> : <CreateListingScreen />}
    </AdminRoute>
  }
/>


        <Route
  path="/admin/customers"
  element={
    <AdminRoute>
      <AdminCustomersScreen />
    </AdminRoute>
  }
/>



<Route
  path="/admin/analytics"
  element={
    <AdminRoute>
      <AdminAnalyticsScreen />
    </AdminRoute>
  }
/>



<Route
  path="/admin/inventory"
  element={
    <AdminRoute>
      <AdminInventoryScreen />
    </AdminRoute>
  }
/>


<Route path="/admin/messages" element={<AdminRoute><AdminMessagesScreen /></AdminRoute>} />
<Route path="/account/addresses" element={<ShippingAddressScreen />} />
<Route path="/account/payments" element={<PaymentMethodsScreen />} />

      </Routes>
    </>
  );
}

function Router() {
  return (
    <BrowserRouter>
      <RouterInner />
    </BrowserRouter>
  );
}

export default Router;